/* sp-h1-categories — carrusel horizontal de categorías.
   JS real portado del bundle (variation-sport.jsx scrollCats):
     el.scrollBy({ left: dir * 340, behavior: 'smooth' });
   Adaptado: el desplazamiento = ancho real de la 1ª tarjeta + gap, para
   respetar card_min_width editable. Binding idempotente (Regla 15). */
(function () {
  function initSection(root) {
    if (!root) return;
    var track = root.querySelector('[data-sp-cats-track]');
    if (!track) return;
    if (track.dataset.spBound === '1') return; // idempotente (editor recarga sección)
    track.dataset.spBound = '1';

    function step() {
      var first = track.firstElementChild;
      if (!first) return 340;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function scrollCats(dir) {
      var max = track.scrollWidth - track.clientWidth;
      // bucle: al final + siguiente → principio; al principio + anterior → final
      if (dir > 0 && track.scrollLeft >= max - 2) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: max, behavior: 'smooth' }); }
      else { track.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
    }

    var prev = root.querySelector('[data-sp-cats-prev]');
    var next = root.querySelector('[data-sp-cats-next]');
    if (prev) prev.addEventListener('click', function () { scrollCats(-1); });
    if (next) next.addEventListener('click', function () { scrollCats(1); });

    var nav = root.querySelector('[data-sp-cats-nav]');
    function toggleNav() {
      if (!nav) return;
      var overflow = track.scrollWidth - track.clientWidth > 2;
      nav.style.display = overflow ? '' : 'none';
    }
    toggleNav();
    window.addEventListener('resize', toggleNav);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.sp-cats');
    nodes.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init al cargar/recargar la sección (idempotente por dataset)
  document.addEventListener('shopify:section:load', function (e) {
    initSection((e.target || document).querySelector('.sp-cats') || e.target);
  });
})();
